// src/utils/sessionHelper.js

export function saveToSession(key, value) {
    if (typeof window !== 'undefined') {
        localStorage.setItem(key, JSON.stringify(value));
    }
}

export function getFromSession(key) {
    if (typeof window !== 'undefined') {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    }
    return null;
}

export function removeFromSession(key) {
    if (typeof window !== 'undefined') {
        localStorage.removeItem(key);
    }
}
